import { FC } from 'react';

import { Environment } from '../../constants/environments';
import { ImagesApp } from '../../constants/images';
import { useI18nContext } from '../../hooks/contexts/i18n.context';
import * as Styles from './styles';

const I18N_PREFIX = ['EVENT_NOT_FOUND_STATE'];

/**
 * "Event not found" state on the tickets page: shown when
 * `GET /public/{eventId}` fails (DictonaryKeys.eventNotFound in event.context).
 * The CTA leads to the site home (Environment.SITE_URL), where the other events are.
 */
const EventNotFoundState: FC = () => {
  const { translate } = useI18nContext();

  return (
    <Styles.Container
      id="event-not-found-state"
      data-testid="event-not-found-state"
    >
      <Styles.Icon
        src={ImagesApp.svg.eventNotFound}
        alt=""
        aria-hidden="true"
        id="event-not-found-icon"
        data-testid="event-not-found-icon"
      />
      <Styles.Content>
        <Styles.Texts>
          <Styles.Title id="event-not-found-title">
            {translate([...I18N_PREFIX, 'TITLE'])}
          </Styles.Title>
          <Styles.Description id="event-not-found-description">
            {translate([...I18N_PREFIX, 'DESCRIPTION'])}
          </Styles.Description>
        </Styles.Texts>
        <Styles.CtaLink href={Environment.SITE_URL} id="event-not-found-cta">
          {translate([...I18N_PREFIX, 'CTA'])}
        </Styles.CtaLink>
      </Styles.Content>
    </Styles.Container>
  );
};

export default EventNotFoundState;
